export default "__VITE_ASSET__BRf92xpJ__"